import { OnInit, ChangeDetectorRef } from '@angular/core';
import { forkJoin } from 'rxjs';
import { UsersService } from '../../../services/users.service';
import { NotificationsService } from '../../../services/notification.service';
import { LocalisationService } from '../../../services/localisation.service';
import { MinutesToReadableTimePipe } from '../../../pipes/minutesToReadableTime.pipe';
import { AppLoadingEventsEmitter } from '../../../events/loading.events';
import { TrainingViewModel } from '../../../viewModels/training.viewModel';
var TrainingInfoSectionComponent = /** @class */ (function () {
    function TrainingInfoSectionComponent(usersService, changeDetectorRef, notificationService, localisationService, minutesToReadableTimePipe, appLoadingEventsEmitter) {
        this.usersService = usersService;
        this.changeDetectorRef = changeDetectorRef;
        this.notificationService = notificationService;
        this.localisationService = localisationService;
        this.minutesToReadableTimePipe = minutesToReadableTimePipe;
        this.appLoadingEventsEmitter = appLoadingEventsEmitter;
        this.editable = true;
        this.notifications = true;
        this.trainings = [];
    }
    TrainingInfoSectionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);
        forkJoin(this.usersService.getTrainings(), this.usersService.getUserTrainingActivities(), this.usersService.getUserTrainingDurations(), this.usersService.getUserActivities())
            .subscribe(function (_a) {
            var trainings = _a[0], trainingActivities = _a[1], trainingDurations = _a[2], activities = _a[3];
            _this.trainings = trainings;
            _this.trainingActivities = trainingActivities;
            _this.trainingDurations = trainingDurations;
            _this.activities = activities;
            _this.currentlySelectedActivity = _this.usersService.userProfile.activity ? _this.activities.find(function (a) { return a.id === _this.usersService.userProfile.activity.id; }) : undefined;
            if (_this.trainings.length <= 0) {
                _this.trainings.push(new TrainingViewModel());
            }
            _this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            _this.changeDetectorRef.markForCheck();
        });
    };
    TrainingInfoSectionComponent.prototype.updateProfile = function () {
        var _this = this;
        var trainingsValidationPassed = true;
        this.trainings.map(function (training) {
            if (!training.day
                || training.day.length <= 0
                || !training.training_activity
                || !training.training_duration) {
                trainingsValidationPassed = false;
            }
        });
        if (!trainingsValidationPassed) {
            this.notificationService.error(this.localisationService.localise('empty_trainings_error'));
            return;
        }
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);
        forkJoin([
            this.usersService.updateUserProfile({ activity: { id: this.currentlySelectedActivity.id } }),
            this.usersService.updateTrainings({ trainings: this.convertToTrainingsDTO() })
        ])
            .subscribe(function () {
            _this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            _this.changeDetectorRef.markForCheck();
            if (_this.notifications) {
                _this.notificationService.success(_this.localisationService.localise('settings_profile_updated_successfully'));
            }
        }, function () {
            _this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
        });
    };
    TrainingInfoSectionComponent.prototype.addTraining = function () {
        this.trainings.push(new TrainingViewModel());
        this.changeDetectorRef.markForCheck();
    };
    TrainingInfoSectionComponent.prototype.removeTraining = function (index) {
        this.trainings.splice(index, 1);
        this.changeDetectorRef.markForCheck();
    };
    TrainingInfoSectionComponent.prototype.duplicateTraining = function (index) {
        this.trainings.push({
            day: this.trainings[index].day,
            training_activity: this.trainings[index].training_activity,
            training_duration: this.trainings[index].training_duration,
        });
        this.changeDetectorRef.markForCheck();
    };
    TrainingInfoSectionComponent.prototype.onDayChange = function (event, index) {
        this.trainings[index].day = event.target.value;
        this.changeDetectorRef.markForCheck();
    };
    TrainingInfoSectionComponent.prototype.onTrainingChange = function (event, index) {
        // tslint:disable-next-line:radix
        this.trainings[index].training_activity = this.trainingActivities.find(function (ta) { return ta.id === parseInt(event.target.value); });
        this.changeDetectorRef.markForCheck();
    };
    TrainingInfoSectionComponent.prototype.onDurationChange = function (event, index) {
        // tslint:disable-next-line:radix
        this.trainings[index].training_duration = this.trainingDurations.find(function (td) { return td.id === parseInt(event.target.value); });
        this.changeDetectorRef.markForCheck();
    };
    TrainingInfoSectionComponent.prototype.onActivitySelected = function (activity) {
        this.currentlySelectedActivity = activity;
    };
    TrainingInfoSectionComponent.prototype.convertToTrainingsDTO = function () {
        var dtoData = [];
        this.trainings.map(function (training) {
            dtoData.push({
                'day': training.day,
                'training_activity_id': training.training_activity.id,
                'training_duration_id': training.training_duration.id,
            });
        });
        return dtoData;
    };
    return TrainingInfoSectionComponent;
}());
export { TrainingInfoSectionComponent };
